import { types } from "mobx-state-tree";
import { withSetPropAction } from "./helpers/withSetPropAction";

export const BottomBarStoreModel = types
  .model("OrderStore")
  .props({
    orderCount: types.optional(types.integer, 0),
  })
  .actions(withSetPropAction)
  .actions((self) => ({
    refreshOrderCount() {
      self.orderCount = ~~(Math.random() * 1000);
    },
  }));
